import { createContext, useContext } from "react";
import type { ChatContextType } from "./state";

export const ChatContext = createContext<ChatContextType>(
	{} as ChatContextType,
);

export const useRedeemCopilotChat = () => useContext(ChatContext);
